export enum ScheinType {
  Kassenschein = 'kassenschein',
  Privatschein = 'privatschein',
  Hzv = 'hzv',
  Other = 'other',
}

export enum ScheinStatusValue {
  Ok = 'ok',
  NoSchein = 'no_schein',
  WrongType = 'wrong_type',
  Unknown = 'unknown',
}

export type BillingScheinStatus = {
  status: ScheinStatusValue;
  expectedType: ScheinType;
  existingTypes: ScheinType[];
};
